import * as ImageManipulator from 'expo-image-manipulator'
import { Easing, Platform } from 'react-native'

import { api } from '../api'

const canShowFieldwireField = (project) => {
  if (!project.has_fieldwire) {
    return false
  }
  if (!project.has_fieldwire_projects) {
    return false
  }
  if (project.fieldwire_projects === null) {
    return false
  }
  if (!project.fieldwire_projects.length) {
    return false
  }
  return true
}

const canShowFieldwireLabel = (project) => {
  if (!project.has_fieldwire) {
    return false
  }
  if (!project.has_fieldwire_projects) {
    return false
  }
  if (project.fieldwire_projects === null) {
    return false
  }
  if (!project.fieldwire_projects.length) {
    return false
  }
  return true
}

const canShowPlanGridField = (project) => {
  if (!project.has_plan_grid) {
    return false
  }
  if (!project.has_plan_grid_projects) {
    return false
  }
  if (project.plan_grid_projects === null) {
    return false
  }
  if (!project.plan_grid_projects.length) {
    return false
  }
  return true
}

const canShowPlanGridLabel = (project) => {
  if (!project.has_plan_grid) {
    return false
  }
  if (!project.has_plan_grid_projects) {
    return false
  }
  if (project.plan_grid_projects === null) {
    return false
  }
  if (!project.plan_grid_projects.length) {
    return false
  }
  return true
}

const findProject = (projects, id) => {
  return projects.data.data.find((project) => project.id === id)
}

const isAuthorizedCOR = (item) => {
  if (!item.requires_auth) {
    return true
  }
  if (item.authorization !== null) {
    return true
  }
  return false
}

const isAuthorizedCORLog = (item) => {
  if (!item.requires_auth) {
    return true
  }
  if (item.authorization !== null) {
    return true
  }
  return false
}

const screenInterpolator = (props) => {
  return {
    opacity: props.position.interpolate({
      inputRange: [props.scene.index - 1, props.scene.index],
      outputRange: [1, 1],
    }),
  }
}

const transitionConfig = () => {
  return {
    screenInterpolator,
    transitionSpec: {
      duration: 500,
      easing: Easing.inOut(Easing.ease),
    },
  }
}

const photoUriToBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

export const uploadPhoto = async (photo) => {
  let file = ''
  if (Platform.OS === 'web') {
    const extension = photo.assets[0].uri.includes('data:image')
      ? /data:image\/(.*);base64,(.*)/.exec(photo.assets[0].uri)
      : ''

    if (extension && extension[1].match(/(jpg|jpeg|png)$/)) {
      const contentType = `image/${extension[1]}`
      const blob = photoUriToBlob(photo.assets[0].uri.replace(/^data:image\/\w+;base64,/, ''), contentType)
      file = new File([blob], `photo.${extension[1]}`, { type: contentType })
    } else {
      alert('You can only upload JPG/PNG file!')
    }
  } else {
    const photoResized = await ImageManipulator.manipulateAsync(
      photo.assets[0].uri,
      [
        {
          resize: {
            width: 600,
            height: 600,
          },
        },
      ],
      {
        format: 'jpeg',
      },
    )
    const name = photoResized.uri.substr(photoResized.uri.lastIndexOf('/') + 1)
    const extension = name.substr(name.lastIndexOf('.') + 1)
    file = {
      name,
      type: `image/${extension}`,
      uri: photoResized.uri,
    }
  }
  if (!file) {
    throw new Error('Invalid Photo')
  }

  const data = new FormData()
  data.append('file', file)

  const response = await api({
    data,
    method: 'POST',
    url: '/photos',
  })
  if (!response.data.url) {
    throw new Error('Invalid Photo')
  }

  return response.data.url
}

const sanitizeNumber = (value) => {
  if (!value) {
    return value
  }
  if (value.includes('.')) {
    if (!isNaN(Number(value))) {
      return value
    }
    return '0.0'
  }
  if (!isNaN(Number(value))) {
    return value
  }
  return '0'
}

export {
  canShowFieldwireField,
  canShowFieldwireLabel,
  canShowPlanGridField,
  canShowPlanGridLabel,
  findProject,
  isAuthorizedCOR,
  isAuthorizedCORLog,
  sanitizeNumber,
  screenInterpolator,
  transitionConfig,
}
